module.exports = __webpack_public_path__ + "static/media/SPOTIFY.1d2b6300.png";